module.exports = __webpack_public_path__ + "static/media/navigation_flow.4ff1d576.jpg";